export default __webpack_public_path__ + "static/media/x-ray.686111dc.png";